import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module'
import { ThemeProvider } from './contexts/ThemeContext';

import Home from './pages/Home.js';
import NotFoundPage from './pages/NotFoundPage.js';
import About from './pages/About.js';
import Contact from './pages/Contact.js';
import Privacy from './pages/Privacy.js';
import OAuthCallback from './pages/OAuthCallback.js';
import Developers from './pages/Developers.js';

// The OAuth callback URL carries the authorization code and state in its
// query string. Keep analytics off that page so those values never reach a
// third party, even transiently.
const isOAuthCallback = window.location.pathname.startsWith('/oauth/');
if (!isOAuthCallback) {
  TagManager.initialize({ gtmId: 'GTM-TQJ2ZJ6J' });
}

function App() {
  return (
    <ThemeProvider>
      <Router>
            <Routes>
              <Route path="/about" element={<About />} />
              <Route path="/developers" element={<Developers />} />
              <Route path="/contact" element={<Contact />}/>
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/oauth/callback" element={<OAuthCallback />} />
              <Route path="/" element={<Home />} /> {/* Default Route */}
              <Route path="*" element={<NotFoundPage />} /> {/* 404 */}
            </Routes>
          </Router>
    </ThemeProvider>
  );
}

export default App;
